import type {ServerError} from '@logistics-frontend/core/utils/network'
import type {Optional} from '@logistics-frontend/types'
import {useTransition} from '@yandex-delivery/blocks'
import {useCallback} from 'react'

import {fetchVerticalsDeprecated} from 'src/shared/api'
import {appConfig} from 'src/shared/config'
import type {FormOrderResponse, GeoPoint} from 'src/shared/types'

import {mapVerticalsToGroups} from './utils/map-verticals-to-groups'
import {toTariffVerticals} from './utils/to-tariff-verticals'

type Options = {
  onSuccess: (verticals: Optional<FormOrderResponse>) => void
}

export function useFetchVerticals() {
  const [{payload, isPending}, startTransition] = useTransition<Optional<FormOrderResponse>, ServerError>(undefined, {
    key: 'fetch/verticals/deprecated',
    shouldShowBaseError: false,
  })

  const fetchVerticalsHandler = useCallback((location?: GeoPoint, options?: Options) => {
    startTransition(() => fetchVerticalsDeprecated(location, appConfig.countryCode), {
      onCommit(result) {
        options?.onSuccess(result)
      },
    })
  }, [])

  return {
    fetchVerticalsHandler,
    verticalGroups: mapVerticalsToGroups(payload),
    verticals: toTariffVerticals(payload),
    isVerticalsPending: isPending,
  }
}
